import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from './locales/en/common.json';
import commonTh from './locales/th/common.json';
import commonZh from './locales/zh/common.json';
import marketplaceEn from './locales/en/marketplace.json';
import marketplaceTh from './locales/th/marketplace.json';
import marketplaceZh from './locales/zh/marketplace.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'th', label: 'ไทย' },
  { code: 'zh', label: '中文' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: commonEn, marketplace: marketplaceEn },
      th: { common: commonTh, marketplace: marketplaceTh },
      zh: { common: commonZh, marketplace: marketplaceZh },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    load: 'languageOnly',
    defaultNS: 'common',
    ns: ['common', 'marketplace'],
    detection: {
      // localStorage wins if the visitor already picked a language (via the
      // switcher); otherwise fall back to the browser/OS language setting.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
